import { activeClientRegistry } from "./activeClientRegistry";
/**
 * Non-hook capture for call-sites outside the React tree. Routes to the active
 * app's client via the registry; returns "" when no capable app is mounted.
 */
const sendException = (error, tags) => activeClientRegistry.capture(error, undefined, tags) ?? "";
export { sendException };
